import { render, staticRenderFns } from "./TemplateEventsReports.vue?vue&type=template&id=25bee3a4&scoped=true&"
import script from "./TemplateEventsReports.vue?vue&type=script&lang=js&"
export * from "./TemplateEventsReports.vue?vue&type=script&lang=js&"
import style0 from "./TemplateEventsReports.vue?vue&type=style&index=0&id=25bee3a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bee3a4",
  null
  
)

export default component.exports